<div class="h-full overflow-auto flex flex-col">
  <div class="flex justify-between p-4 text-xl font-bold items-center border-b">
    Opere attive
  </div>

  <div class="h-full overflow-auto">
    <table>
      <thead class="sticky top-0 bg-gray-200 shadow">
        <tr>
          <th>Opera</th>
          <th>Artista</th>
          <th>Data inserimento</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @if (artworks.isLoading()) {
          <tr><td colspan="4" class="p-6 text-gray-400">Caricamento...</td></tr>
        } @else if (!artworks.value()?.data?.length) {
          <tr><td colspan="4" class="p-6 text-gray-400">Nessuna opera attiva trovata.</td></tr>
        } @else {
          @for (row of artworks.value()!.data; track row.id) {
            <tr [class.bg-gray-100]="$even" [class.bg-gray-200]="$odd">
              <td>
                <div class="flex gap-4 items-center">
                  @if (row.mainAttachment) {
                    <img class="w-28 h-28 object-cover shrink-0" [src]="row.mainAttachment.url" [alt]="row.name">
                  } @else {
                    <div class="w-28 h-28 bg-gray-300 shrink-0"></div>
                  }
                  <div class="flex flex-col gap-1">
                    <div class="font-bold">{{ row.name }}</div>
                    <div class="text-sm text-gray-600 capitalize">{{ row.type.toLowerCase() }}</div>
                    <div class="text-sm text-gray-600">{{ row.technique }}</div>
                    <div class="text-sm font-semibold">{{ row.price | currency : 'EUR' : '€ ' : '1.2-2' }}</div>
                    <div class="text-xs text-gray-500">{{ row.status }}</div>
                  </div>
                </div>
              </td>
              <td>{{ row.artistName || (row.artist.firstName + ' ' + row.artist.lastName) }}</td>
              <td>{{ row.createdAt | date : 'dd-MM-yyyy' }}</td>
              <td>
                <div class="flex gap-4">
                  <button wunButton danger (click)="showDeleteModal.set(true); selectedArtwork.set(row)">Elimina</button>
                  <a wunButton primary [routerLink]="['/','backoffice','users', row.artist.id, 'details', 'artworks', row.id]">Gestisci</a>
                </div>
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>
</div>

<cms-modal [(show)]="showDeleteModal">
  <div class="flex justify-center">
    <div class="p-6 bg-white flex flex-col gap-3 rounded-sm">
      <div class="text-xl font-bold">Elimina opera "{{selectedArtwork()?.name}}"</div>
      <div>
        Attenzione! L'opera verrà eliminata definitivamente.
      </div>
      <div class="flex gap-3 justify-end">
        <button wunButton danger (click)="deleteArtwork()">Elimina</button>
        <button wunButton primary (click)="cancelDelete()">Annulla</button>
      </div>
    </div>
  </div>
</cms-modal>
